<template>
  <section>
    <div class="header_bg"></div>
    <div class="header_bg" :class="{ fixed: isHeaderFixed }">
      <div class="header">
        <div class="logo">
          <router-link to="/"
            ><img src="@/assets/images/logo.png" alt="Logo Image"
          /></router-link>
        </div>
        <nav>
          <router-link :class="path1" to="/portfolio"
            ><span>포트폴리오</span></router-link
          >
          <router-link :class="path2" to="/price"
            ><span>견적</span></router-link
          >
          <router-link :class="path3" to="/tech"><span>Tech</span></router-link>
          <router-link :class="path4" to="/about"
            ><span>About us</span></router-link
          >
        </nav>
      </div>

      <HeaderMobile/>
    </div>
  </section>
</template>

<script>
import loginService from "../services/loginService";
import HeaderMobile from "../components/HeaderMobile.vue";
export default {
  data() {
    return {
      isHeaderFixed: true,
      isSxApplied: false,
    };
  },
  components: {
    HeaderMobile,
  },
  computed: {
    path1() {
      return {
        on: this.$route.path === "/portfolio",
        off: this.$route.path !== "/portfolio",
        ani_up: true,
      };
    },
    path2() {
      return {
        on: this.$route.path === "/price",
        off: this.$route.path !== "/price",
        ani_up: true,
      };
    },
    path3() {
      return {
        on: this.$route.path === "/tech",
        off: this.$route.path !== "/tech",
        ani_up: true,
      };
    },
    path4() {
      return {
        on: this.$route.path === "/about",
        off: this.$route.path !== "/about",
        ani_up: true,
      };
    },
  },
  mounted() {
    window.addEventListener("scroll", function () {}, false);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      console.log("handleScroll");
      this.isHeaderFixed = window.scrollY > 0;
    },
  },
};
</script>

<style scoped>
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  width: 100vw;
  max-width: 1140px;
  padding: 0 20px 0px 20px;
}

nav {
  display: flex;
  gap: 50px;
}

.menu {
  display: none;
}

.logo img {
  max-width: 180px;
}
.header_bg {
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 90px;
  background-color: #fff;
  box-shadow: 0px 2px 8px #00000026;
  transition: top 0.3s ease-in-out; /* 스크롤 이벤트 시 부드러운 전환 적용 */
  opacity: 0.95;
}

.header span {
  font-weight: 500;
  padding: 5px;
}

.off {
  color: #000000;
}

.on {
  color: #215fe6;
  border-bottom: 2px solid #215fe6;
}

.header_bg.fixed {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
}


@media screen and (max-width: 1440px) {
  
  .header {
    display: none;
  }
  .header_bg {
    display: flex;
    justify-content: center;
    width: 100vw;
    height: 60px;
    background-color: #fff;
    box-shadow: 0px 2px 8px #00000026;
    transition: top 0.3s ease-in-out; /* 스크롤 이벤트 시 부드러운 전환 적용 */
  }

  /* 로고 스타일 */
  .logo img {
    max-width: 140px;
  }

  /* 네비게이션 스타일 */
  nav {
    display: none;
    gap: 50p;
  }
}

/* 네비게이션 메뉴 스타일 */
nav span {
  font-size: 18px;
  cursor: pointer;
}
</style>
